import {
    SET_ORDER_HISTORY,
    NOTIFICATION_TEXT
} from '../actions/types';

const INITIAL_STATE = {
    orderList: [],
    notificationText: ''
};

export default (state = INITIAL_STATE, action) => {

    switch (action.type) {
        case SET_ORDER_HISTORY:
            return { ...state, orderList: action.payload };
        case NOTIFICATION_TEXT:
            return { ...state, notificationText: action.payload };
        default:
            return state;
    }

}